export default __webpack_public_path__ + "static/1-f1c09c80c5a81268a1621270366dd2be.webp";